export const getEventsIsFetching = state => state.eventsReducer.isFetching;
export const getEventsError = state => state.eventsReducer.error;
export const getEvents = state => state.eventsReducer.events;
export const getSingleEvent = (state, id) => state.eventsReducer.events[id];
